import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Form, Table } from 'react-bootstrap';
import FormInputs from '../../../Utils/FormInputs';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

export default function GSTTaxReport() {
    // datatable
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableACGSTTaxtReport')) {
            $('#mainDatatableACGSTTaxtReport').DataTable({
                dom: "flrtip",
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
        }
    }, []);


    const initialInputData = {
        branch_select: '',
    }

    const [inputData, setInputData] = useState(initialInputData);
    const handleGstTaxReptChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleGstTaxReptSubmit = (e) => {
        e.preventDefault();
    };
    const gstTaxReptRows = [
        {
            columns: [
                {
                    size: { md: 12 }, label: 'Branch', type: 'multiSelect', isMulti: 'true', placeholder: 'Select branch...', name: 'branch_select', id: 'branchSelect', value: inputData.branch_select, errormsg: '',
                    options: [
                        { value: "Test", label: "Test" },
                        { value: "Umesh bhai", label: "Umesh bhai" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                    ],
                },
            ]
        },
    ];
    const gstTaxReptButtons = [];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-sm-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-sm-0'>GST Tax Report</Card.Title>
                                            <Form>
                                                <div className='min-sm-w'></div>
                                                <Form.Select  size="sm">
                                                    <option>All Time</option>
                                                    <option value="1">One</option>
                                                    <option value="2">Two</option>
                                                </Form.Select>
                                            </Form>
                                        </div>
                                        <FormInputs Buttons={gstTaxReptButtons} rows={gstTaxReptRows} handleInputChange={handleGstTaxReptChange} handleSubmit={handleGstTaxReptSubmit} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-lg-flex justify-content-between align-items-center mb-3">
                                            <ul className='list-inline text-dark fw-medium mb-0'>
                                                <li className='list-inline-item border py-3 px-4 rounded mb-3 mb-lg-0'>Credit (Cr.): 0</li>
                                                <li className='list-inline-item border py-3 px-4 rounded mb-3 mb-lg-0'>Debit (Dr.): 0</li>
                                                <li className='list-inline-item border py-3 px-4 rounded mb-3 mb-lg-0'>Closing Balance: 0</li>
                                            </ul>
                                        </div>

                                        <Table responsive bordered className='table-nowrap mb-0' id='mainDatatableACGSTTaxtReport'>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Date</th>
                                                    <th>Transaction Type</th>
                                                    <th>Reff. No.</th>
                                                    <th>Debits(Dr.)</th>
                                                    <th>Credits(Cr.)</th>
                                                    <th>Closing Balance</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>28/12/2022</td>
                                                    <td>Opening balance</td>
                                                    <td>0</td>
                                                    <td>0</td>
                                                    <td>0</td>
                                                    <td>0</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
